import { Button, Icon, Text } from '@cubeyou-team/hx-react-components';
import { AI_GRADIENT_PROPERTIES } from '@discover-frontend/constants';
import React, { FC } from 'react';

import translations from 'src/lang';

const { STANLEY_QUERY: translation } = translations['en-US'];

interface StanleyQueryPanelErrorStateProps {
  onTryAgain: () => void;
}

export const StanleyQueryPanelErrorState: FC<
  StanleyQueryPanelErrorStateProps
> = ({ onTryAgain }) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 pb-40 max-w-sm mx-auto">
      <Icon icon="icon-ai" size="xxlarge" gradient={AI_GRADIENT_PROPERTIES} />
      <Text size="body" align="center">
        {translation.MODAL.ERROR.TITLE}
      </Text>
      <Button
        type="button"
        size="small"
        variant="primary"
        onClick={onTryAgain}
      >
        {translation.MODAL.ERROR.TRY_AGAIN}
      </Button>
    </div>
  );
};
